import { mapActions, mapGetters } from 'vuex';
import { setAuthHeader } from '@/config/axios/index';

export default {
  computed: {
    ...mapGetters([
      'userAutoLoginData',
      'userIsLogged'
    ]),
  },

  created() {
    let urlParams = (new URL(document.location)).searchParams;

    if(urlParams.get('token') && urlParams.get('refresh_token') && urlParams.get('client_id')){
      if(this.userIsLogged) {
        // Logout if system is already authenticated
        this.$router.replace({ name: 'Home', query: {} }).catch(() => {});
        this.$store.dispatch('userLogout');
      } else {
        this.autoLogin();
      }
    } else {
      this.autoLogin();
    }
  },

  methods: {
    ...mapActions([
      'userAutoLoginKeycloak',
      'userResetAutoLoginData'
    ]),

    /**
     * Makes user login when the userAutoLoginData is set in store
     */
    async autoLogin() {
      if (!this.userAutoLoginData) {
        return;
      }

      /**
       * If the auto login data are from URL
       * we need to clear url params
       */
      if (this.userAutoLoginData.origin === 'URL') {
        // Clearing the token and user id from URL
        const params = { ...this.$route.query };

        delete params.token;
        delete params.refresh_token;
        delete params.client_id;
        this.$router.replace({ query: { ...params } }).catch(() => {});
      }

      // Getting the user data from Keyclock

      try {
				await Promise.all([
					this.userAutoLoginKeycloak(this.userAutoLoginData),
					setAuthHeader(this.userAutoLoginData.token),
				]);
      } catch (error) {
        //
      }

      this.userResetAutoLoginData();
    },
  },
};
